import type { App } from "vue";
import PrimeVue from "primevue/config";
import ToastService from "primevue/toastservice";
import ConfirmationService from "primevue/confirmationservice";
import Aura from "@primevue/themes/aura";

const LS_THEME = "luckydesk.theme";
const DARK_CLASS = "app-dark";

export type ThemeMode = "light" | "dark";

export function detectTheme(): ThemeMode {
  const saved = localStorage.getItem(LS_THEME) as ThemeMode | null;
  if (saved === "light" || saved === "dark") return saved;
  return window.matchMedia?.("(prefers-color-scheme: dark)").matches ? "dark" : "light";
}

export function applyTheme(mode: ThemeMode) {
  const root = document.documentElement;
  if (mode === "dark") root.classList.add(DARK_CLASS);
  else root.classList.remove(DARK_CLASS);
  localStorage.setItem(LS_THEME, mode);
}

export function installPrimeVue(app: App) {
  app.use(PrimeVue, {
    theme: {
      preset: Aura,
      options: {
        prefix: "p",
        darkModeSelector: `.${DARK_CLASS}`,
        cssLayer: false,
      },
    },
    ripple: true,
  });
  app.use(ToastService);
  app.use(ConfirmationService);
  applyTheme(detectTheme());
}
